module.exports = __webpack_public_path__ + "static/media/ox-cart.47902f34.png";